module.exports = __webpack_public_path__ + "asset/image-Running-9c45e57eae2e1c19.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/Running.svg
// module id = Wl94
// module chunks = 0